import _ from "lodash";

export const sumTotal = (data: any[], field: string) => {
	return _.sumBy(data, (item: any) => +item[field]);
};